import { Extension, Content } from '@tiptap/core';

interface ValidateContentOptions {
   parsedContent: Content;
   fallbackHandler: (err: any) => void;
}

export const ValidateContent = Extension.create<ValidateContentOptions>({
   name: 'validateContent',

   addOptions() {
      return {
         parsedContent: {},
         fallbackHandler: (err: any) => {},
      };
   },

   onCreate() {
      // String content cannot be invalid
      if (typeof this.options.parsedContent === 'string') {
         return;
      }

      try {
         const doc = this.editor.schema.nodeFromJSON(this.options.parsedContent);
         doc.check();
      } catch (err) {
         if (this.options.fallbackHandler) {
            this.options.fallbackHandler(err);
         }
      }
   },
});
